import React, { useEffect, useMemo, useState } from "react";
import KapalService from "../../services/kapal/KapalService";

const StatusKapal = ({kodeStatus}) => {

    let kapalService = useMemo(() => new KapalService(), [])
    const [uraianStatus, setUraianStatus] = useState('')

    useEffect(() => {
        const getStatusDok = async () => {
            const response = await kapalService.getRefStatusPermohonanKapalById(kodeStatus)
            setUraianStatus(response.data.uraianStatus)
        }
        getStatusDok()
    }, [kapalService, kodeStatus])

    return (
        <>
            {uraianStatus}
        </>
    )
}

export default StatusKapal